import React from "react";
import { useTranslation } from "react-i18next";
import { SFDublicateIcon } from "../../icons";
import SFIconButton from "../../button/iconButton";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton)(() => ({
  marginLeft: "auto",
  padding: 2,
}));

const CloneButton = (props) => {
  const { t } = useTranslation();
  return (
    <SFIconButtonStyled
      title={t("components.queryBuilder.duplicateLabel")}
      onClick={props.handleOnClick}
    >
      <SFDublicateIcon size="xsmall" color="grey400" />
    </SFIconButtonStyled>
  );
};

export default CloneButton;
